import React, { memo } from 'react';
import { ProductoCard, Producto } from './ProductoCard';
type Props = {
  id: string;
  variant: 'origen' | 'memoria' | 'pausa';
  numero: string;
  nombre: string;
  descripcion: string;
  productos: Producto[];
  testimonio: {
    quote: string;
    autor: string;
  };
};
export function Coleccion({
  id,
  variant,
  numero,
  nombre,
  descripcion,
  productos
}: Props) {
  return <section className={`coleccion coleccion--${variant}`} id={id} data-id="element-66">
      <div className="savia-container" data-id="element-67">
        <div className="coleccion__header" data-id="element-68">
          <div className="reveal-left" data-id="element-69">
            <p className="coleccion__numero" data-id="element-70">{numero}</p>
            <h2 className="coleccion__nombre" data-id="element-71">{nombre}</h2>
          </div>
          <p className="coleccion__descripcion reveal-right" data-id="element-72">{descripcion}</p>
        </div>
        <div className="coleccion__grid" data-id="element-73">
          {productos.map((p, i) => <ProductoCard key={p.nombre} producto={p} delay={i + 1} data-id="element-74" />)}
        </div>
      </div>
    </section>;
}